const separatorPattern = /8=FIXT?\.\d\.\d([^\d]+)/i;
export const detectFixMessageSeparator = (line: string): string | null => {
  const matches = separatorPattern.exec(line);
  if (matches && matches.length >= 2) {
    return matches[1];
  }

  return null;
};
